var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"is-visible":_vm.isLoading}}),_c('owners-delete-modal',{attrs:{"modal":_vm.modal,"owner":_vm.owner},on:{"oncancel":_vm.closeOwnerDelete,"onsubmit":_vm.ownerDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }